"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getName = exports.getSecureName = exports.getFullName = void 0;
function getFullName(fio) {
    return (fio.lastName ? fio.lastName + ' ' : '') + fio.firstName + (fio.middleName ? ' ' + fio.middleName : '');
}
exports.getFullName = getFullName;
function getSecureName(fio) {
    return (fio.firstName +
        (fio.middleName ? ' ' + fio.middleName : '') +
        (fio.lastName ? ' ' + fio.lastName.charAt(0).toUpperCase() + '.' : ''));
}
exports.getSecureName = getSecureName;
function getName(fio) {
    return (fio.lastName ? fio.lastName + ' ' : '') + fio.firstName;
}
exports.getName = getName;
//# sourceMappingURL=index.js.map